import * as React from 'react'
import { Link } from 'react-navi'

import { isPc } from '../../../utils/env'

import './tab_bar.scss'
import TabBarVoteIcon from '../../../images/tab_bar_vote_icon.png'
import TabBarVoteSelectedIcon from '../../../images/tab_bar_vote_selected_icon.png'
import TabBarRankIcon from '../../../images/tab_bar_rank_icon.png'
import TabBarRankSelectedIcon from '../../../images/tab_bar_rank_selected_icon.png'
import TabBarCommentIcon from '../../../images/tab_bar_comment_icon.png'
import TabBarCommentSelectedIcon from '../../../images/tab_bar_comment_selected_icon.png'

import { IProps, IState } from './interface'

class TabBar extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            tabBarList: []
        }
    }

    public componentWillMount = () => {
        this.init()
    }

    public componentWillReceiveProps = () => {
        this.init()
    }

    public render = () => {
        const { currentText } = this.props.data
        const { tabBarList } = this.state
        return (
            <ul className={['tab-bar', isPc(window.navigator.userAgent) ? 'tab-bar-pc' : ''].join(' ')}>
                {tabBarList.map(item => {
                    return <Link href={item.path} key={item.text}>
                        <li className={`item${item.text === currentText ? ' selected' : ''}`}>
                            <img className="icon" src={item.text === currentText ? item.selectedIconPath : item.iconPath} />
                            <span>{item.text}</span>
                        </li>
                    </Link>
                })}
            </ul>
        )
    }

    private init = () => {
        const { groupId, activityId } = this.props.data
        this.setState({
            tabBarList: [{
                text: '投票',
                path: `/group/${groupId}/detail/${activityId}`,
                iconPath: TabBarVoteIcon,
                selectedIconPath: TabBarVoteSelectedIcon
            }, {
                text: '排名',
                path: `/group/${groupId}/detail/${activityId}/rank`,
                iconPath: TabBarRankIcon,
                selectedIconPath: TabBarRankSelectedIcon
            }, {
                text: '评论',
                path: `/comments/${groupId}/detail/${activityId}`,
                iconPath: TabBarCommentIcon,
                selectedIconPath: TabBarCommentSelectedIcon
            }]
        })
    }
}

export {
    TabBar
}


// WEBPACK FOOTER //
// ./src/components/common/tab_bar/tab_bar.tsx